<script setup lang="ts">
import ExternalMaterialFallbackIcon from '@/core/supportMeasures/ExternalMaterialFallbackIcon.vue';

/** A material's logo, or its fallback icon when it has none; the parent sets the box size. */
defineProps<{
  logoUrl: string | null;
  /** A material a teacher added (not from the catalog). */
  custom: boolean;
  largeIcon?: boolean;
}>();
</script>

<template>
  <img
    v-if="logoUrl"
    :src="logoUrl"
    alt=""
    class="shrink-0 rounded-lg border border-surface-secondary bg-white object-contain"
  />
  <ExternalMaterialFallbackIcon v-else :custom="custom" :large-icon="largeIcon" />
</template>
